import { all } from "redux-saga/effects";

// App sagas
import auth from "./auth/saga";
import common from "./common/saga";
import storageSaga from "./storageSaga";
import profileMain from "./profileMain/saga";

// export globally running saga
export default function* rootSaga() {
  yield all([
    auth(),
    common(),
    storageSaga(),
    profileMain(),
  ]);
}
